import * as p from "react/jsx-runtime";
import { jsx as m } from "react/jsx-runtime";
import u from "remark-gfm";
import { evaluateSync as d } from "@mdx-js/mdx";
import { MDXProvider as f, useMDXComponents as l } from "@mdx-js/react";
import * as a from "react";
import { useCopilotInstruction as g } from "./global-state.js";
import { undent as C } from "../session.js";
function F({ children: t, components: e }) {
  const { componentsForRendering: r, extraComponentDescription: n } = a.useMemo(() => {
    const i = {}, c = [];
    for (const [s, o] of Object.entries(e))
      typeof o == "function" ? i[s] = o : o && typeof o.component == "function" && (i[s] = o.component, c.push(`### ${s}
${C(o.description).trim()}`));
    return { componentsForRendering: i, extraComponentDescription: c.join(`

`) };
  }, [e]);
  return g({
    instruction: `## Content Guidelines

1. You have access to github flavored markdown. Lean on it to make your responses more readable and engaging. 
${n.length > 0 ? `2. In addition. You are rendering this chat with MDX. This means you can use the following React components in your responses.

For example, if you have a component called \`ProfileCard\`, you can use it like this:

# Some title

Some text

<ProfileCard userId="12345" />

List of available components:    

${n}` : ""}`
  }), /* @__PURE__ */ m(f, { components: r, children: t });
}
const h = {
  remarkPlugins: [u],
  Fragment: a.Fragment,
  ...p
};
function j({ children: t }) {
  const e = l(), r = a.useMemo(() => {
    try {
      return d(t, { ...h, useMDXComponents: () => e }).default;
    } catch (n) {
      return console.error("Error evaluating MDX content:", n), () => /* @__PURE__ */ m("div", { children: "Error rendering content" });
    }
  }, [t, e]);
  return /* @__PURE__ */ m(r, {});
}
export {
  F as CopilotProvider,
  j as Markdown
};
